import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Styles/Styles/dashboardstyle.css";

import rightImage from "../../Assets/img/test.png";
import Logo from "../../Assets/img/logo.png";

import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BASE_URL, security_key } from "../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinearProgress from "@mui/material/LinearProgress";

const ForgetPassword = () => {
  const navigate = useNavigate();

  const formRef = useRef(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    user_email: "",
  };

  const validationSchema = Yup.object().shape({
    user_email: Yup.string()
      .email("Invalid email")
      .required("Email is required")
      .strict(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (formValues) => {
      toast.dismiss();
      setIsSubmitting(true);
      try {
        const response = await axios.post(`${BASE_URL}API/apicall`, {
          security_key,
          mode: "checkEmail",
          ...formValues,
        });

        const output = response.data;

        if (output === 1) {
          toast.success("OTP sent to Mail", { autoClose: 3000 });
          setTimeout(
            () =>
              navigate("/forget-verify", {
                state: { email: formValues.user_email },
              }),
            3000
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const imgDimensions = {
    width: "520px",
    height: "520px",
  };

  const pStyle = {
    width: "70%",
    fontSize: "16px",
    fontWeight: "500",
  };

  const linkStyle = {
    fontSize: "16px",
    textDecoration: "none",
  };

  const iconStyle = {
    fontSize: "10px",
  };

  return (
    <>
      <ToastContainer position="top-center" />
      <section className="bg-1 site-main">
        <div className="container vh-100 d-flex justify-content-center align-items-center">
          <div className="site-sub-main bg-white">
            <div className="field d-none d-lg-block bg-1 ">
              <div className="wrapper">
                <div className="sub-wrapp d-flex align-items-center justify-content-center mt-5">
                  <div className="text-box-right text-start p-4 ">
                    <h2 className="fw-bold fs-3">Forgot Password</h2>
                    <p className="mb-1">
                      Enter your registered email address to receive a
                      verification code
                    </p>
                  </div>
                </div>
                <div className="sub-wrapp">
                  <img
                    src={rightImage}
                    className="img-fluid"
                    width={"529.09px"}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="field" style={{ height: "520px" }}>
              {/* <div className="text-header text-center d-flex flex-column align-items-center"></div> */}
              <form
                className="d-flex flex-column justify-content-center align-items-center h-100"
                onSubmit={formik.handleSubmit}
                ref={formRef}
              >
                <h2 className="fw-semibold text-center fs-4 mb-15">
                  Forgotten Password
                </h2>

                <div className="input-field mb-3">
                  <input
                    type="email"
                    className="form-control"
                    name="user_email"
                    value={formik.values.user_email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <label>Email Address</label>
                  {formik.touched.user_email && formik.errors.user_email && (
                    <div className="text-danger">
                      {formik.errors.user_email}
                    </div>
                  )}
                </div>
                <div className="btn-grp mt-3 w-100 text-center">
                  <button
                    type="submit"
                    className="btn btn-dark submit-btn fw-semibold"
                    disabled={isSubmitting}
                  >
                    Get OTP
                  </button>
                </div>
                {isSubmitting && (
                  <LinearProgress
                    sx={{
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "black", // Change the progress bar color to black
                      },
                    }}
                  />
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
      <style jsx>{``}</style>
    </>
  );
};

export default ForgetPassword;
